import React, { useState } from 'react'
import AOS from "aos"; // Import AOS library
import Banner from '../components/Banner'
import Breadcrumb from '../components/Breadcrumb'
import DeveloperStartsFrom from '../components/DeveloperStartsFrom'
import DeveloperProjectSec from '../sections/developerProject/DeveloperProjectSec'
import { useParams } from 'react-router-dom';
import * as constants from "../constants";
import { fetchAPI } from '../helper/fetchAPI';
import { decodeId, deslugify, detectScript, getDecodedPathParam, replacePathParams, slugify } from '../helper/helperFunction';
import CustomHelmet from '../components/CustomHelmet';
import { t } from 'i18next';
import FullScreenLoader from '../components/FullScreenLoader';
import NotFoundSec from '../sections/pageNotFound/NotFoundSec';
import { useTranslation } from 'react-i18next';
import { useCountryPrefix } from '../routes/useCountryPrefix';

const DeveloperProject = () => {
    const countryPrefix = useCountryPrefix();
    const { i18n } = useTranslation();

    let { developerName, idDeveloper, cityName } = useParams();
    const [developerProject, setDeveloperProject] = useState();
    const [contactUs, setContactUs] = useState();
    const [developersDetail, setDevelopersDetail] = useState();
    const isArabic = i18n.language === "ar";
    const language = isArabic ? "ar" : "en";
    const [isLoaded, setIsLoaded] = useState(false);
    const [pageIndex, setPageIndex] = useState(1);
    const [loadingMore, setLoadingMore] = React.useState(false);
    const [loadError, setLoadError] = useState(false);


    let apiUrl = process.env.REACT_APP_API_URL;
    let langUrl = process.env.REACT_APP_API_URL;


    const fetchData = async (pageIndex) => {
        apiUrl = `${apiUrl}${constants.developerproject}?language=${language}&region_id=${countryPrefix}&developerId=${decodeId(idDeveloper)}${cityName ? `&cityName=${deslugify(cityName)}` : ''}&PageIndex=${pageIndex}&PageSize=10`;
        const res = await fetchAPI(apiUrl, "Get");
        if (res?.status === 200) {
            setDeveloperProject((prevData) => ({
                ...prevData,
                items: [...(prevData?.items || []), ...(res?.data?.items || [])],
                totalPages: res?.data?.totalPages ?? prevData.totalPages,
                pageIndex: res?.data?.pageIndex ?? prevData.pageIndex,
            }))
            setContactUs(res?.data?.contactDetails)
            setDevelopersDetail(res?.data?.developerDetails)
            setIsLoaded(true)
            setLoadingMore(false)
        } else {
            setLoadError(true); // set error flag
            setIsLoaded(true);
        }
    }

    const fetchContentData = async (pageIndex) => {

        const currentUrl = window.location.href;
        let replacement = {};
        let convPath = getDecodedPathParam(currentUrl, "developers/:developerName/:idDeveloper", "developerName")

        if ((language === "en" && detectScript(convPath) === "arabic") || (language === "ar" && detectScript(convPath) === "english")) {

            langUrl = `${langUrl}${constants.localization}?DeveloperName=${developerName}${cityName ? `&CityName=${encodeURIComponent(cityName)}` : ''}`
            const res = await fetchAPI(langUrl, "Get");

            if (res?.status === 200) {

                const pattern = `${countryPrefix}${language === "ar" ? "/ar" : ""}/developers${cityName ? `/:cityName` : ""}/:developerName/:idDeveloper`;
                replacement = {
                    developerName: slugify(isArabic ? res.data.developerName.ar : res.data.developerName.en),
                    ...(cityName ? { cityName: slugify(isArabic ? res.data.cityName.ar : res.data.cityName.en) } : null)
                }
                var newUrl = replacePathParams(currentUrl, pattern, replacement)
                //const newUrl = cityName === undefined ? currentUrl.replace(/\/developers\/[^\/]+/, `/developers/${slugify(isArabic ? res.data.developerName.ar : res.data.developerName.en)}`) : '';
                window.history.replaceState({}, '', newUrl);
            }
            cityName = cityName ? replacement.cityName : undefined
        }

        // developerName = replacement.developerName
        fetchData(pageIndex);
    }

    React.useEffect(() => {
        AOS.init();

        fetchContentData(pageIndex);
    }, [pageIndex]);

    const handleLoadMore = () => {
        setLoadingMore(true)
        setPageIndex(prev => prev + 1);

    };
    //const pathName = ["Home", "Developer", "Project"]
    const pathLang = isArabic ? "/ar" : "";
    const pathName = [
        { name: t("home"), path: `/${countryPrefix}${pathLang ? `${pathLang}` : ""}` },
        { name: t("developers"), path: `/${countryPrefix}${pathLang ? `${pathLang}` : ""}/developers` },
        { name: developersDetail?.developerName || "" },
    ];

    if (!isLoaded) {
        return (
            <FullScreenLoader />
        )
    }

    if (loadError) {
        return (
            <NotFoundSec title={t("opps")} desc={t("dev_project_not_found")} img={"/assets/img/not-found.svg"} cssstyle={"p-0"} />)
    }

    return (
        <>
            <CustomHelmet
                title={"Exclusive Real Estate Across Egypt"}
                desc={'Connect Homes makes exploring real estate in Egypt simple and seamless.'}
            />
            <Banner
                title={t("projects")}
                desc={t("banner_desc")}>
            </Banner>
            <Breadcrumb pathName={pathName}>
            </Breadcrumb>
            <DeveloperStartsFrom companyName={developersDetail?.developerName} location={developersDetail?.location} priceStart={developersDetail?.minPrice || 0} priceEnd={developersDetail?.maxPrice || 0} developerLogo={developersDetail?.thumbnailImage} phone={contactUs?.phone} whatsApp={contactUs?.whatsApp}></DeveloperStartsFrom>

            <DeveloperProjectSec data={developerProject} developersDetailData={developersDetail} onLoadMore={handleLoadMore} loadingMore={loadingMore}></DeveloperProjectSec>
        </>
    )
}

export default DeveloperProject